module.exports = __webpack_public_path__ + "static/media/peijiansuopei643.909cd59b.png";